<template>
  <v-list dense>
    <template v-for="item in menus">
      <v-row v-if="item.heading" :key="item.heading" align="center">
        <v-col cols="6">
          <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
        </v-col>
        <v-col cols="6" class="text-center">
          <a href="#!" class="body-2 black--text">EDIT</a>
        </v-col>
      </v-row>
      <v-list-group
        v-else-if="item.children"
        :key="item.title"
        v-model="item.model"
        :append-icon="item.model ? item.icon : item['icon-alt']"
        link
        :to="item.title"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="child in item.children"
          :key="child.title"
          link
          :to="child.title"
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item v-else :key="item.title" link :to="item.title">
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
// import axios from "axios";
export default {
  data: () => ({
    // menus: [],
    // menus: [
    //   { icon: 'mdi-home', text: 'Dashboard', title: 'dashboard' },
    //   {
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Pengguna',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-account-clock',
    //         text: 'Proses Registrasi',
    //         title: 'verifikasi-user'
    //       },
    //       {
    //         icon: 'mdi-account-check',
    //         text: 'Registrasi Diterima',
    //         title: 'verifikasi-selesai'
    //       },
    //       {
    //         icon: 'mdi-account-cancel',
    //         text: 'Registrasi Ditolak',
    //         title: 'verifikasi-ditolak'
    //       },
    //       {
    //         icon: 'mdi-account-multiple',
    //         text: 'List Pengguna',
    //         title: 'user'
    //       },
    //       {
    //         icon: 'mdi-ticket-account',
    //         text: 'Reward Dealer',
    //         title: 'reward-dealer'
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'mdi-panorama',
    //     text: 'Transaksi',
    //     title: 'transaksi'
    //   },

    //   { icon: 'mdi-motorbike', text: 'Moderasi', title: 'moderasi' },
    //   // { icon: 'mdi-account', text: 'User', title: 'user' },
    //   {
    //     icon: 'mdi-map-marker',
    //     text: 'Alamat',
    //     title: 'verifikasi-alamat'
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Iklan',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-panorama',
    //         text: 'List Iklan',
    //         title: 'list_iklan?tab=semua'
    //       },
    //       {
    //         icon: 'mdi-panorama',
    //         text: 'Event',
    //         title: 'event'
    //       },
    //       {
    //         icon: 'mdi-panorama',
    //         text: 'Popup',
    //         title: 'popup'
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Saldo',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-cash',
    //         text: 'Pencairan Saldo',
    //         title: 'pencairan_saldo'
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Tiket',
    //     model: true,
    //     children: [
    //       // {
    //       //   icon: 'mdi-ticket-confirmation',
    //       //   text: 'Pembelian Tiket',
    //       //   title: 'pembelian_tiket'
    //       // },
    //       // {
    //       //   icon: 'mdi-history',
    //       //   text: 'Pengembalian Tiket',
    //       //   title: 'pengembalian_tiket'
    //       // },
    //       {
    //         icon: 'mdi-history',
    //         text: 'Refund Tiket',
    //         title: 'refund_tiket'
    //       },
    //       {
    //         icon: 'mdi-history',
    //         text: 'Transfer Dana',
    //         title: 'transfer_dana'
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Report',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-folder-download',
    //         text: 'Report Iklan',
    //         title: 'report-iklan'
    //       },
    //       {
    //         icon: 'mdi-folder-download',
    //         text: 'Report Lelang & Klik',
    //         title: 'report-lelang'
    //       }
    //     ]
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Master',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-book-open-page-variant',
    //         text: 'Tipe Unit',
    //         title: 'tipe-unit'
    //       },
    //     ]
    //   },
    //   {
    //     icon: 'mdi-chevron-up',
    //     'icon-alt': 'mdi-chevron-down',
    //     text: 'Setup',
    //     model: true,
    //     children: [
    //       {
    //         icon: 'mdi-image-area',
    //         text: 'Banner',
    //         title: 'banner'
    //       },
    //       {
    //         icon: 'mdi-image-area',
    //         text: 'Service',
    //         title: 'service'
    //       }
    //       // {
    //       //   icon: 'mdi-book',
    //       //   text: 'Module',
    //       //   title: 'module'
    //       // },
    //       // {
    //       //   icon: 'mdi-select-group',
    //       //   text: 'Category',
    //       //   title: 'category'
    //       // },
    //       // {
    //       //   icon: 'mdi-account-group',
    //       //   text: 'Role',
    //       //   title: 'role'
    //       // },
    //       // {
    //       //   icon: 'mdi-account-group',
    //       //   text: 'Role Menu',
    //       //   title: 'role_menu'
    //       // },
    //       // {
    //       //   icon: 'mdi-image',
    //       //   text: 'Jenis Iklan',
    //       //   title: 'jenis_iklan'
    //       // }
    //     ]
    //   }
    // ]
    idPrivilageUser: null,
    menus: []
  }),
  async created() {
    let usersJson = JSON.parse(localStorage.getItem('user'));

    this.idPrivilageUser = usersJson.id_privileges;
    console.log('idPrivilageUser : ' + this.idPrivilageUser);

    switch (this.idPrivilageUser) {
      case 3:
        this.menus = [
          {
            icon: 'mdi-home',
            text: 'Dashboard',
            title: 'dashboard'
          },
          {
            'icon-alt': 'mdi-chevron-down',
            text: 'Pengguna',
            model: true,
            children: [
              {
                icon: 'mdi-account-clock',
                text: 'Proses Registrasi',
                title: 'verifikasi-user'
              },
              {
                icon: 'mdi-account-check',
                text: 'Registrasi Diterima',
                title: 'verifikasi-selesai'
              },
              {
                icon: 'mdi-account-cancel',
                text: 'Registrasi Ditolak',
                title: 'verifikasi-ditolak'
              },
              {
                icon: 'mdi-account-multiple',
                text: 'List Pengguna',
                title: 'user'
              },
              {
                icon: 'mdi-map-marker',
                text: 'Alamat',
                title: 'verifikasi-alamat'
              }
            ]
          },
          {
            icon: 'mdi-chevron-up',
            'icon-alt': 'mdi-chevron-down',
            text: 'Iklan',
            model: true,
            children: [
              {
                icon: 'mdi-panorama',
                text: 'List Iklan',
                title: 'list_iklan?tab=semua'
              },
              {
                icon: 'mdi-panorama',
                text: 'Event',
                title: 'event'
              },
              {
                icon: 'mdi-panorama',
                text: 'Popup',
                title: 'popup'
              }
            ]
          }
        ];
        break;
      default:
        this.menus = [
          {
            icon: 'mdi-home',
            text: 'Dashboard',
            title: 'dashboard'
          },
          {
            'icon-alt': 'mdi-chevron-down',
            text: 'Pengguna',
            model: true,
            children: [
              {
                icon: 'mdi-account-clock',
                text: 'Proses Registrasi',
                title: 'verifikasi-user'
              },
              {
                icon: 'mdi-account-check',
                text: 'Registrasi Diterima',
                title: 'verifikasi-selesai'
              },
              {
                icon: 'mdi-account-cancel',
                text: 'Registrasi Ditolak',
                title: 'verifikasi-ditolak'
              },
              {
                icon: 'mdi-account-multiple',
                text: 'List Pengguna',
                title: 'user'
              },
              // {
              //   icon: 'mdi-ticket-account',
              //   text: 'Reward Dealer',
              //   title: 'reward-dealer'
              // }
            ]
          },
          {
            icon: 'mdi-panorama',
            text: 'Transaksi',
            title: 'transaksi'
          },

          // {
          //   icon: 'mdi-motorbike',
          //   text: 'Moderasi',
          //   title: 'moderasi'
          // },
          // { icon: 'mdi-account', text: 'User', title: 'user' },
          {
            icon: 'mdi-map-marker',
            text: 'Alamat',
            title: 'verifikasi-alamat'
          },
          {
            icon: 'mdi-chevron-up',
            'icon-alt': 'mdi-chevron-down',
            text: 'Iklan',
            model: true,
            children: [
              {
                icon: 'mdi-panorama',
                text: 'List Iklan',
                title: 'list_iklan?tab=semua'
              },
              // {
              //   icon: 'mdi-panorama',
              //   text: 'Event',
              //   title: 'event'
              // },
              {
                icon: 'mdi-panorama',
                text: 'Popup',
                title: 'popup'
              }
            ]
          },
          // {
          //   icon: 'mdi-chevron-up',
          //   'icon-alt': 'mdi-chevron-down',
          //   text: 'Saldo',
          //   model: true,
          //   children: [
          //     {
          //       icon: 'mdi-cash',
          //       text: 'Pencairan Saldo',
          //       title: 'pencairan_saldo'
          //     }
          //   ]
          // },
          // {
          //   icon: 'mdi-chevron-up',
          //   'icon-alt': 'mdi-chevron-down',
          //   text: 'Tiket',
          //   model: true,
          //   children: [
          //     // {
          //     //   icon: 'mdi-ticket-confirmation',
          //     //   text: 'Pembelian Tiket',
          //     //   title: 'pembelian_tiket'
          //     // },
          //     // {
          //     //   icon: 'mdi-history',
          //     //   text: 'Pengembalian Tiket',
          //     //   title: 'pengembalian_tiket'
          //     // },
          //     {
          //       icon: 'mdi-history',
          //       text: 'Refund Tiket',
          //       title: 'refund_tiket'
          //     },
          //     {
          //       icon: 'mdi-history',
          //       text: 'Transfer Dana',
          //       title: 'transfer_dana'
          //     }
          //   ]
          // },
          {
            icon: 'mdi-chevron-up',
            'icon-alt': 'mdi-chevron-down',
            text: 'Report',
            model: true,
            children: [
              {
                icon: 'mdi-folder-download',
                text: 'Report Iklan',
                title: 'report-iklan'
              },
              {
                icon: 'mdi-folder-download',
                text: 'Report Lelang & Klik',
                title: 'report-lelang'
              }
            ]
          },
          {
            icon: 'mdi-chevron-up',
            'icon-alt': 'mdi-chevron-down',
            text: 'Master',
            model: true,
            children: [
              {
                icon: 'mdi-book-open-page-variant',
                text: 'Tipe Unit',
                title: 'tipe-unit'
              }
            ]
          },
          {
            icon: 'mdi-chevron-up',
            'icon-alt': 'mdi-chevron-down',
            text: 'Setup',
            model: true,
            children: [
              {
                icon: 'mdi-image-area',
                text: 'Banner',
                title: 'banner'
              },
              {
                icon: 'mdi-image-area',
                text: 'Service',
                title: 'service'
              }
              // {
              //   icon: 'mdi-book',
              //   text: 'Module',
              //   title: 'module'
              // },
              // {
              //   icon: 'mdi-select-group',
              //   text: 'Category',
              //   title: 'category'
              // },
              // {
              //   icon: 'mdi-account-group',
              //   text: 'Role',
              //   title: 'role'
              // },
              // {
              //   icon: 'mdi-account-group',
              //   text: 'Role Menu',
              //   title: 'role_menu'
              // },
              // {
              //   icon: 'mdi-image',
              //   text: 'Jenis Iklan',
              //   title: 'jenis_iklan'
              // }
            ]
          }
        ];
        break;
    }
  }
};
</script>
